import { observer } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'

import { StateContainer } from '@/components/ui/StateContainer'
import { getDealersBillingKpis } from '@/services/billing.service'
import { DashboardStoreContext } from '@/stores/DashboardStore'
import { formatCurrency, formatMonthName } from '@/utils/formatters'

import Dealers from './Dealers'

const Billing = observer(() => {
  // Context
  const { type } = useContext(DashboardStoreContext)
  const navigate = useNavigate()

  // State
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const [kpis, setKpis] = useState({})
  const [appliedFilters, setAppliedFilters] = useState('')

  const fetchBillingKpis = async (filterQuery = '') => {
    const data = await getDealersBillingKpis(setLoading, setError, () => {}, filterQuery)
    if (data) {
      setKpis(data)
    }
  }
  useEffect(() => {
    fetchBillingKpis(appliedFilters)
  }, [appliedFilters])

  useEffect(() => {
    if (type === 'dealer') {
      navigate('/')
    }
  }, [type])

  const currentMonth = formatMonthName(kpis.currentMonth)
  const previousMonth = formatMonthName(kpis.previousMonth)

  return (
    <>
      <Helmet>
        <title>Billing</title>
      </Helmet>

      <StateContainer async error={error} loading={loading}>
        {() => (
          <>
            <div>
              <div className="flex items-center">
                <h5>Billing</h5>
              </div>
              <div className="grid flex-none grid-cols-1 gap-2 sm:grid-cols-2  md:grid-cols-3">
                <div className="bg-midnight col-span-1 row-span-1 flex flex-col items-center justify-center rounded-lg px-3 pb-2 pt-3 sm:col-span-1 md:col-span-1 md:row-span-1">
                  <span className="text-brownGray text-xs uppercase leading-4 tracking-[1.5px]">
                    {currentMonth} Running Total
                  </span>
                  <span className="text-brownGray text-lg font-semibold leading-8 tracking-[-1px]">
                    {formatCurrency(kpis.currentMonthTotal)}
                  </span>
                </div>
                <div className="bg-midnight col-span-1 row-span-1 flex flex-col items-center justify-center rounded-lg px-3 pb-2 pt-3 sm:col-span-1 md:col-span-1 md:row-span-1">
                  <span className="text-brownGray text-xs uppercase leading-4 tracking-[1.5px]">
                    {previousMonth} Total
                  </span>
                  <span className="text-brownGray text-lg font-semibold leading-8 tracking-[-1px]">
                    {formatCurrency(kpis.previousMonthTotal)}
                  </span>
                </div>
                <div className="bg-midnight col-span-1 row-span-1 flex flex-col items-center justify-center rounded-lg px-3 pb-2 pt-3 sm:col-span-1 md:col-span-1 md:row-span-1">
                  <span className="text-brownGray text-xs uppercase leading-4 tracking-[1.5px]">
                    YTD Through {previousMonth}
                  </span>
                  <span className="text-brownGray text-lg font-semibold leading-8 tracking-[-1px]">
                    {formatCurrency(kpis.ytdThruPrevMonth)}
                  </span>
                </div>
              </div>
            </div>
            <Dealers
              currentMonth={currentMonth}
              previousMonth={previousMonth}
              onFiltersChange={setAppliedFilters}
            />
          </>
        )}
      </StateContainer>
    </>
  )
})

export default Billing
